import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { typography, colors } from '../../styles';

const styles = css`
  display: block;
  width: 100%;
  margin: 0;
  background-color: #ffffff;
.ShowcaseSection {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 270px;
  height: auto;
  padding: 70px 0;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media (min-width: 992px) {
    height: auto;
    padding: 100px 0;
  }
  @media (min-width: 1200px) {
    height: auto;
    padding:200px 0;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(180deg, rgba(0,0,0,0.15) 7%, rgba(0,0,0,0.35) 100%);
    z-index: 1;
    transition: all .5s ease-out;
    opacity: 0;
  }
  }
  .Showcase_titleWrapper {
    position: relative;
    z-index: 5;
    height: auto;
  }
  .Showcase_preTitle {
    font-family: ${typography.Serif};
    font-weight: 700;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0.46px;
    text-align: center;
    font-style: italic;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
    @media (min-width: 560px) {
      font-size: 28px;
    }
    @media (min-width: 992px) {
      font-size: 32px;
    }
  }
  .Showcase_title {
    font-family: ${typography.SansSerif};
    font-weight: 200;
    font-size: 30px;
    color: #FFFFFF;
    letter-spacing: 2px;
    text-align: center;
    line-height: 1;
    padding:0 15px;
    text-transform: uppercase;
    text-shadow: 0 1px 3px rgba(0,0,0,0.3);
    @media (min-width: 560px) {
      font-size: 35px;
    }
    @media (min-width: 768px) {
      font-size: 50px;
    }
    @media (min-width: 992px) {
      font-size: 75px;
    }
  }
  .ShowcaseCopy {
    font-weight: 500;
    font-family: ${typography.SansSerif};
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    max-width: 90%;
    margin: 0 auto;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
    @media (min-width: 768px) {
      max-width: 85%;
      font-size: 18px;
      line-height: 26px;
    }
    @media (min-width: 992px) {
      max-width: 70%;
      font-size: 18px;
      margin: 30px auto;
      line-height: 30px;
      font-weight: 500;
    }
    @media (min-width: 1200px) {
      max-width: 65%;
    }
  }
  .ShowcaseLink {
    position: relative;
    transition: all .3s ease-in;
    z-index: 2;
    display: block;
    margin: 0 auto;
    width: auto;
    max-width: 200px;
    margin-top: 30px;
    font-size: 16px;
    background-color: ${colors.color2};
    @media (min-width: 992px) {
      font-size: 19px;
      max-width: 250px;
    }
  }
  .ShowcaseSection:hover {
    &:after {
      opacity: 1;
    }
  }
`;

function ShowcaseSections({ page }) {
  return (
    <div className={styles}>
      {page.showcase_sections.map(item => (
        <div className="ShowcaseSection" style={{ backgroundImage: `url('${buildThumbnailUrl(get(item, 'background_image.contentUrl'))}')` }} key={item.title}>
          <div className="Showcase_titleWrapper">
            <h4 className="Showcase_preTitle">{item.pretitle}</h4>
            <h4 className="Showcase_title">{item.title}</h4>
            <p className="ShowcaseCopy">{item.copy}</p>
            <a href={item.route}><div className="Btn ShowcaseLink">{item.link_name}</div></a>
          </div>
        </div>
      ))}
    </div>
  );
}
ShowcaseSections.propTypes = {
  page: PropTypes.object.isRequired,
};
export default withData({
  page: 'cta_buttons',
})(ShowcaseSections);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/ShowcaseSections.js